import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'

const FETCH_HERO_NEWS_ITEM_REQUEST = 'HeroNewsItem/FETCH_HERO_NEWS_ITEM_REQUEST'
const FETCH_HERO_NEWS_ITEM_SUCCESS = 'Location/FETCH_HERO_NEWS_ITEM_SUCCESS'
const FETCH_HERO_NEWS_ITEM_FAILURE = 'Location/FETCH_HERO_NEWS_ITEM_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  heroNewsItem: [],
  locationObj: {}
}

// Default Reducer
const heroNewsItem = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HERO_NEWS_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_NEWS_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroNewsItem: action.payload
      }
    case FETCH_HERO_NEWS_ITEM_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default heroNewsItem

// Action Creators
export const fetchHeroNewsItem = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_NEWS_ITEM_REQUEST
      })

      const response = await API.get(EndPoints.HERO_NEWS_ITEM + `/all`)
      dispatch({
        type: FETCH_HERO_NEWS_ITEM_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_NEWS_ITEM_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/heroNewsItems.js